import { withI18n } from 'react-i18next';
import CheckoutCard from './CheckoutCard';

import { connect } from 'react-redux';
import { IInitialState } from 'src/store/initialState';
import { checkoutShippingMethod } from 'src/store/modules/checkout';

const mapStateToProps = (state: IInitialState) => ({
  shippingMethodGlobal: checkoutShippingMethod(state)
});

const mapDispatchToProps = (dispatch: any) => ({});

export const pureComponent = CheckoutCard;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(CheckoutCard));
